module.exports = __webpack_public_path__ + "static/media/musgrave.305d36ee.jpg";